import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TInspectionTaskLink } from '../types/types';

const initialState:
    {
        inspectionTaskLinks: TInspectionTaskLink[]

    } = {
        inspectionTaskLinks: []
}

const InspectionTaskLinks = createSlice({
    name: 'InspectionTaskLinks',
    initialState,
    reducers: {
        addInspectionTaskLinks: (state, action: PayloadAction<TInspectionTaskLink[]>) => {
            state.inspectionTaskLinks = action.payload
        },
        addSingleTaskLink: (state, action: PayloadAction<TInspectionTaskLink>) => {
            state.inspectionTaskLinks.push(action.payload);
        },
        updateSingleTaskLink: (state, action: PayloadAction<TInspectionTaskLink>) => {
            const index = state.inspectionTaskLinks.findIndex(
                link => Number(link.itLinkId) === Number(action.payload.itLinkId)
            );
            if (index !== -1) {
                state.inspectionTaskLinks[index] = action.payload;
            }
        },
        removeSingleTaskLink: (state, action: PayloadAction<number>) => {
            state.inspectionTaskLinks = state.inspectionTaskLinks.filter(
                link => Number(link.itLinkId) !== Number(action.payload)
            );
        },
        removeLinksForTask: (state, action: PayloadAction<number>) => {
            state.inspectionTaskLinks = state.inspectionTaskLinks.filter(
                link => Number(link.inspectionTaskId) !== Number(action.payload)
            );
        },
        addMultipleTaskLinks: (state, action: PayloadAction<TInspectionTaskLink[]>) => {
            state.inspectionTaskLinks.push(...action.payload);
        },
    },
});

export const { addInspectionTaskLinks, addSingleTaskLink, updateSingleTaskLink, removeSingleTaskLink, removeLinksForTask, addMultipleTaskLinks } = InspectionTaskLinks.actions;

export default InspectionTaskLinks.reducer;
